import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const chopsticksPractice: BlogMetaData = {
  title: '箸の練習はいつから？始め方5ステップと矯正箸に頼りすぎないコツ',
  description:
    '箸の練習はいつから始める？スプーンが安定した後の三本指の使い方、矯正箸に頼りすぎない環境づくりと始め方5ステップ、こぼす・遊び食べへの対処法をモンテッソーリ「日常生活の練習」の視点で解説します。',
  thumbnailUrl: '/img/blog-chopsticks-practice.webp',
  filePath: buildBlogFilePath('chopsticks-practice'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
